<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-04-29 15:41:02
 * @LastEditors: JDY
-->
<template>
  <div :class="wrpCls">
    <a-tooltip placement="bottom">
      <template slot="title">
        <span>使用文档</span>
      </template>
      <div class="icon-list"><a-icon type="question-circle" /></div>
    </a-tooltip>
    <a-tooltip placement="bottom">
      <template slot="title">
        <span>站内消息</span>
      </template>
      <div class="icon-list">
        <a-badge :count="5" title="Custom hover text">
          <a-icon type="bell" />
        </a-badge>
      </div>
    </a-tooltip>
    <avatar-dropdown :menu="showMenu" :class="prefixCls" />
    <div class="icon-list">
      <select-lang/>
    </div>
  </div>
</template>

<script>
import AvatarDropdown from './AvatarDropdown'
import SelectLang from '@/components/SelectLang'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    SelectLang
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-global-header-index-action'
    },
    isMobile: {
      type: Boolean,
      default: () => false
    },
    topMenu: {
      type: Boolean,
      required: true
    },
    theme: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showMenu: true
    }
  },
  computed: {
    wrpCls () {
      return {
        'ant-pro-global-header-index-right': true,
        [`ant-pro-global-header-index-${(this.isMobile || !this.topMenu) ? 'light' : this.theme}`]: true
      }
    }
  },
  mounted () {

  }
}
</script>

<style lang="less" scoped>
.ant-pro-global-header-index-right {
  display: flex;
}
.icon-list {
  padding: 0 15px;
  display: flex;
  align-items: center;
  i {
    font-size: 1rem;
  }
  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}

</style>
